import React from "react";
import Helmet from "react-helmet";
import { Link } from "gatsby";
import { Layout, Drawer, Button } from "antd";
import { Mobile, Tablet } from "../utils/Responsive";
import MainMenu from "./TheMainMenu";
import TheFooter from "./TheFooter";
import logo from "../img/orgbiochem_logo.svg";

import styles from "../components/style/layout.module.less";
const { Header, Content, Footer } = Layout;
class SiteLayout extends React.Component {
  state = { visible: false };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const { data, children } = this.props;
    return (
      <div className={styles.orgbiochem}>
        <Helmet title="OrgBioChem Group">
          <link
            href="https://fonts.googleapis.com/css?family=Poppins:400,700"
            rel="stylesheet"
          />
        </Helmet>
        <Layout>
          <Header className={styles.header}>
            <Link to="/">
              <img src={logo} alt={data.site.siteMetadata.title} />
            </Link>
            <Tablet>
              <MainMenu className={styles.menu} mode="horizontal" />
            </Tablet>
            <Mobile>
              <div className={styles.collapsedMenu}>
                <Button
                  type="primary"
                  icon="menu"
                  ghost
                  onClick={this.showDrawer}
                />
                <Drawer
                  height={320}
                  placement="bottom"
                  closable={true}
                  onClose={this.onClose}
                  visible={this.state.visible}
                >
                  <MainMenu className={styles.mobilemenu} mode="inline" />
                </Drawer>
              </div>
            </Mobile>
          </Header>
          <Content className={styles.content}>{children}</Content>
          <Footer className={styles.footer}>
            <TheFooter />
          </Footer>
        </Layout>
      </div>
    );
  }
}

export default SiteLayout;
